const columns = [
  {
    name: 'User',
    selector: (row) => row?.name_tx,
    sortable: true,
    sortField: 'name_tx',
  },
  {
    name: 'Company',
    selector: (row) => row?.company_tx,
    sortable: true,
    sortField: 'company_tx',
  },
  {
    name: 'Address',
    selector: (row) => row?.address_tx,
    sortable: true,
    sortField: 'address_tx',
  },
  {
    name: 'Congregation',
    selector: (row) => row?.user_congregation,
    sortable: true,
    sortField: 'user_congregation',
  }, 
  {
    name: 'Devices',
    selector: (row) => row?.device_count,
    sortable: true,
    sortField: 'device_count',
  }
];
const mobileColumns = [
  {
    name: 'User',
    selector: (row) => row?.name_tx,
    sortable: true,
    sortField: 'name_tx',
  },
  {
    name: 'Address',
    selector: (row) => row?.address_tx,
    sortable: true,
    sortField: 'address_tx',
  },
];

export { columns, mobileColumns };
